import { Card, CardBody, CardFooter,Image,Stack,Text,ButtonGroup,Button, useStatStyles} from '@chakra-ui/react'
import { useEffect,useState } from 'react'
import { getCartData } from '../Redux/CartReducer/cartAction'



function CardProduct({id,image,title,price,rating=""}){
    // const {cartData,setCartData}=useContext(Authcontext)
  const [cardData,setCartData]=useState([])
    
 

   useEffect(()=>{
   
      
   },[])


   
   const handleCart = async() => {
    let cardData={
      image:image,
      title:title,
      price:price
    }

    let res=await fetch("https://anthro-backen.onrender.com/cart",{
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body:JSON.stringify(cardData)
    })

    if(res.ok===true){
      alert("product is added")
    }


    
    
   }
  
   
    return (
        
<>

 <Card  

 
 >
  <CardBody>
   <Stack>
    <Image src={image} alt="img"/>
    <Text>{title}</Text>
    <Text>${price}</Text>
    <Text >{rating?`${rating}`:""}</Text>
   </Stack>
   
  </CardBody>
  
  <CardFooter>
    <ButtonGroup spacing='2'>
      <Button variant='solid' colorScheme='blue'>
        Buy now
      </Button>
      <Button variant='ghost' colorScheme='blue' 
      onClick={()=>handleCart(id)}
      >
        Add to cart
      </Button>
    </ButtonGroup>
  </CardFooter>
</Card>
</> 
    )

}


export default CardProduct